<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-06 09:45:28
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-10 17:09:12
 * @Description: 新增地址
-->
<template>
  <div class="addArea">
    <el-form :model="input" :inline="true" :rules="rules" ref="input">
      <el-form-item label="地址信息：" prop="area">
        <div class="select-list">
          <el-select
            placeholder="请选择省"
            @change="handleProvinceChoose"
            v-model="input.province"
            value-key="name"
            class="select"
          >
            <el-option
              v-for="(item, index) in provinceList"
              :key="index"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select
            :disabled="input.province && cityList.length ? false : true"
            v-model="input.city"
            value-key="name"
            placeholder="请选择市"
            @change="handleCityChoose"
            class="select"
          >
            <el-option
              v-for="(item, index) in cityList"
              :key="index"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select
            :disabled="input.city && areaList.length ? false : true"
            v-model="input.area"
            value-key="name"
            placeholder="请选择区"
            class="select"
            @change="handleAreaChoose"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item :label="`${$t('order.detailAddress')}：`" prop="address">
        <el-input
          v-model.trim="input.address"
          type="text"
          maxlength="100"
          :placeholder="$t('order.detailAddressHolder')"
        />
      </el-form-item>
      <el-form-item :label="`${$t('order.recipient')}：`" prop="receiveGoodsPerson">
        <el-input
          v-model.trim="input.receiveGoodsPerson"
          type="text"
          maxlength="20"
          :placeholder="$t('order.recipientHolder')"
        />
      </el-form-item>
      <el-form-item :label="`${$t('order.contact')}：`" prop="receiveGoodsPhone">
        <el-input
          v-model.number="input.receiveGoodsPhone"
          type="text"
          maxlength="11"
          :placeholder="$t('order.contactHolder')"
        />
      </el-form-item>
      <el-form-item label="" prop="defaultAddress">
        <el-checkbox
          v-model="input.defaultAddress"
          text-color="#333333"
          fill="#1D65A8"
          class="defaultbox"
        >
          {{$t('order.defaultAddress2')}}
        </el-checkbox>
      </el-form-item>
      <el-form-item label="" class="align-right" prop="defaultAddress">
        <el-button
          class="default-btn"
          :loading="butLoading"
          @click="handleClose"
          size="small"
          >{{$t('cancel')}}</el-button
        >
        <el-button
          type="primary"
          size="small"
          :loading="butLoading"
          @click="handleAddAddress"
          >{{$t('common.save')}}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { phoneReg } from '@/utils/reg'
export default {
  props: {
    detail: {
      type: Object,
      default: function () {
        return null
      }
    }
  },
  data () {
    return {
      input: {
        userAddressId: '', // 编辑主键
        province: '', // 省
        city: '', // 市
        area: '', // 区
        address: '', // 详细地址
        receiveGoodsPerson: '', // 收货人姓名
        receiveGoodsPhone: '', // 手机号
        defaultAddress: false // 是否默认地址
      },
      rules: {
        area: [
          {
            required: true,
            message: '请选择地址信息',
            trigger: 'change'
          }
        ],
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        receiveGoodsPerson: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        receiveGoodsPhone: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          {
            pattern: phoneReg,
            message: '请输入正确的手机号码',
            trigger: 'blur'
          }
        ],
        defaultAddress: [{ required: true }]
      },
      butLoading: false,
      provinceList: [],
      cityList: [],
      areaList: []
    }
  },
  created () {
    this.getProvince()
    // 编辑 省市区逻辑待补充
    if (this.detail && this.detail.userAddressId) {
      const keys = Object.keys(this.input)
      keys.forEach((key) => {
        this.input[key] = this.detail[key]
      })
    }
  },
  methods: {
    // 选中省
    handleProvinceChoose (item) {
      this.getCity(item.codeP)
      this.input.province = item.name
      this.input.city = ''
      this.input.area = ''
    },
    // 选中市
    handleCityChoose (item) {
      this.getArea(item.codeC)
      this.input.city = item.name
      this.input.area = ''
    },
    // 选中区
    handleAreaChoose (item) {
      this.input.area = item.name
    },
    // 获取省
    getProvince () {
      this.$http
        .get(`/front/sys/sysProvince/provinceList`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.provinceList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取省份失败')
        })
    },
    // 获取市
    getCity (value) {
      this.$http
        .get(`/front/sys/sysProvince/cityList/${value}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.cityList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('获取城市失败')
        })
    },
    // 获取区
    getArea (value) {
      this.$http
        .get(`/front/sys/sysProvince/areaList/${value}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.areaList = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {})
    },
    // 执行提交
    doSubmit (obj, isAdd) {
      let url = '/front/consumer/user/address/addUserAddress'
      if (!isAdd) {
        url = '/front/consumer/user/address/updateUserAddress'
      }
      this.butLoading = true
      this.$http
        .post(url, obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(isAdd ? this.$t('message.addSuccess') : this.$t('message.updateSuccess'))
            this.$emit('success')
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.butLoading = false
        })
    },
    // 保存地址
    handleAddAddress () {
      this.$refs.input.validate((valid) => {
        if (!valid) {
          return
        }
        // 新增
        const obj = {
          ...this.input
        }
        if (obj.userAddressId === '') {
          delete obj.userAddressId
          this.doSubmit(obj, true)
        } else {
          this.doSubmit(obj, false)
        }
      })
    },
    // 关闭弹窗
    handleClose () {
      this.$emit('handleClose')
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item {
  display: flex;
  margin: 0 0 22px 0;
}

/deep/ .el-form-item__label {
  width: 120px;
}

/deep/ .el-form-item__content {
  flex: 1;
}

.select-list {
  display: flex;
  justify-content: space-between;
  margin-right: -12px;
  .select {
    flex: 1;
    margin-right: 12px;
  }
}

.align-right {
  text-align: right;
  margin-bottom: 0;
}

.defaultbox {
  margin-left: 120px;
}
</style>
